import { inject, Injectable } from "@angular/core";
import { CommandHandlerFor, Http } from "@skylab-angular-shared/core";
import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from "@skylab-shared/core";

export interface ProductsAssociateEInvoiceSymbolParams {
    eInvoiceSymbol: string;
    clientId: number;
    productId: number;
    productExternalId: string;
}

export class ProductsAssociateEInvoiceSymbolCommand extends Command<ProductsAssociateEInvoiceSymbolParams, void>{}

@CommandHandlerFor(ProductsAssociateEInvoiceSymbolCommand)
@Injectable({ providedIn: 'root'})
export class ProductsAssociateEInvoiceSymbolCommandHandler implements CommandHandler<ProductsAssociateEInvoiceSymbolCommand, ProductsAssociateEInvoiceSymbolParams, void>{
    #Url = TaggedUrl.join('products/createAssociatedEInvoiceSymbol', [Tags.Api]);
    #http = inject(Http) as HttpService;

    public async handleAsync(command: ProductsAssociateEInvoiceSymbolCommand): Promise<void> {
        await this.#http.post(this.#Url, command.params);
    }
}
